export const formatDate = (date: Date | string | null | undefined): string => {
  if (!date) {
    return "--";
  }

  let utcDate: Date;
  if (typeof date === "string") {
    utcDate = new Date(date);
  } else {
    utcDate = date;
  }

  const today = new Date();
  const isToday =
    utcDate.getDate() === today.getDate() &&
    utcDate.getMonth() === today.getMonth() &&
    utcDate.getFullYear() === today.getFullYear();

  if (isToday) {
    return new Intl.DateTimeFormat(undefined, {
      hour: "numeric",
      minute: "2-digit",
    }).format(utcDate);
  } else {
    return new Intl.DateTimeFormat(undefined, {
      month: "short",
      day: "numeric",
    }).format(utcDate);
  }
};
export const timeAgo = function (date: Date | string | null): string {
  if (!date) {
    return "never";
  }

  const now = new Date();
  if (typeof date == "string") {
    date = new Date(date);
  }

  const seconds = Math.floor((now.getTime() - date.getTime()) / 1000);

  const minutes = Math.floor(seconds / 60);
  const hours = Math.floor(minutes / 60);
  const days = Math.floor(hours / 24);

  if (days > 0) {
    return `${days}d ${hours % 24}h ago`;
  } else if (hours > 0) {
    return `${hours}h ${minutes % 60}m ago`;
  } else if (minutes > 0) {
    return `${minutes}m ${seconds % 60}s ago`;
  } else {
    return `${seconds}s ago`;
  }
};

export const getInitials = (firstName: string, lastName: string): string => {
  return `${firstName ? firstName.charAt(0) : "¿"}${lastName ? lastName.charAt(0) : "?"}`.toUpperCase();
};
